import React, { useEffect, useState } from 'react';
import Styles from './styles.module.css';
import { doc, getFirestore, updateDoc } from 'firebase/firestore';

type ManageMemoProps = {
  memoToggle: any;
  setMemoToggle: React.Dispatch<React.SetStateAction<any>>;
};

// チャットのメモ(chats/{id}.meta.memo)の編集モーダル。応募者管理(6.manage)と
// 応募者・審査(15.evaluation)で共通に使う。見た目はほかの画面の確認モーダル
// (1.manual/4.sending/3.send_modal など)と同じテイストにそろえている。
const ManageMemo: React.FC<ManageMemoProps> = ({ memoToggle, setMemoToggle }) => {

  const [ memoText, setMemoText ] = useState<string>(memoToggle.memo);
  const [ saving, setSaving ] = useState<boolean>(false);
  const [ error, setError ] = useState<string>('');

  const close = () => setMemoToggle({ id: "", name: "", memo: "" });

  // Esc キーでも閉じられるようにする(保存中は閉じない)
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => { if (e.key === 'Escape' && !saving) close(); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  });

  async function save() {
    if (saving) return;
    setSaving(true);
    setError('');
    try {
      await updateDoc(doc(getFirestore(), "chats", memoToggle.id), {
        "meta.memo": memoText,
      });
      close();
    } catch (e) {
      console.error('メモの保存に失敗しました', e);
      setError('メモの保存に失敗しました。時間をおいて、もう一度お試しください。');
      setSaving(false);
    }
  }

  return (
    <div className={Styles.overlay} role='dialog' aria-modal='true' aria-labelledby='memo-title'>
      <div className={Styles.scrim} onClick={() => !saving && close()} />
      <div className={Styles.card}>
        <h3 id='memo-title' className={Styles.title}>メモ</h3>
        <p className={Styles.subtitle}>{memoToggle.name}さん</p>

        <textarea
          className={Styles.textarea}
          value={memoText}
          placeholder='面談の印象や、次に確認したいことなどを残しておけます'
          onChange={(e) => setMemoText(e.target.value)}
          autoFocus
        />

        {error && <p className={Styles.error} role='alert'>{error}</p>}

        <div className={Styles.actions}>
          <button type='button' className={Styles.cancel} disabled={saving} onClick={close}>
            キャンセル
          </button>
          <button type='button' className={Styles.confirm} disabled={saving} onClick={save}>
            {saving ? '保存中...' : '保存'}
          </button>
        </div>
      </div>
    </div>
  );
}

export default ManageMemo;
